import { IMAGE_GENERATION_FORM_DEFAULTS } from './ImageGenerationFormState';
import { VIDEO_GENERATION_FORM_DEFAULTS } from './VideoGenerationFormState';
import {
    getImageGenerationCreditCost,
    getUpscaleCreditCost,
    getVideoGenerationCreditCost,
    VIDEO_EDIT_CREDIT_COST,
} from './constants';
import {
    type AiToolkitCategory,
    type AiToolkitFormStates,
    type AiToolkitOperation,
    type AiToolkitSubmitStates,
    AI_TOOLKIT_CATEGORIES,
    AI_TOOLKIT_OPERATIONS,
} from './types';

export type CreditCostOptions = {
    operation?: AiToolkitOperation;
    /** An upscale is billed on the finished edit's duration, which lives in submit state rather than the form. */
    submitStates: AiToolkitSubmitStates;
};

export const getCreditCost = (
    category: AiToolkitCategory,
    formStates: AiToolkitFormStates,
    options?: CreditCostOptions,
): number => {
    switch (category) {
        case AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION: {
            const duration = Number(formStates[category]?.duration ?? VIDEO_GENERATION_FORM_DEFAULTS.duration);
            return getVideoGenerationCreditCost(duration);
        }
        case AI_TOOLKIT_CATEGORIES.IMAGE_GENERATION: {
            const resolution = formStates[category]?.resolution ?? IMAGE_GENERATION_FORM_DEFAULTS.resolution;
            return getImageGenerationCreditCost(resolution);
        }
        case AI_TOOLKIT_CATEGORIES.VIDEO_EDIT:
            if (options?.operation === AI_TOOLKIT_OPERATIONS.UPSCALE) {
                return getUpscaleCreditCost(options.submitStates[category].duration);
            }
            return VIDEO_EDIT_CREDIT_COST;
        case AI_TOOLKIT_CATEGORIES.VOICEOVER:
            return 0;
    }
};
